<template>
  <p class="summaryTitle">
    <span class="no1 block"></span>
    <span class="no2 block"></span>
    <span class="no3 block"></span>
    <span class="name">{{title}}</span>
    <span class="no3 block"></span>
    <span class="no2 block"></span>
    <span class="no1 block"></span>
  </p>
</template>

<script>
export default {
  name: "SummaryTitle",
  props:['title']
}
</script>

<style scoped lang="less">
  .summaryTitle {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    height: 28px;
    font-weight: bold;
    margin-bottom: 10px;
    .name {
      padding: 0 3px;
    }
    .block {
      display: block;
      width: 8px;
      height: 8px;
      margin: 0 6px;
      border-radius: 4px;
    }
    .no1 {
      background: rgba(92, 92, 92, 0.3);
    }
    .no2 {
      background: rgba(92, 92, 92, 0.7);
    }
    .no3 {
      background: #5C5C5C;
    }
  }
</style>